import { CardContainer } from "components/elements";
import EmployeeSalaryLateEarlyDeductTable from "components/table/EmployeeSalaryLateEarlyDeductTable";

function EmployeeSalaryLateEarlyDeduct({
  pagination = {},
  isLoading = false,
  lateEarlyDeductList = [],
  onChange = () => { },
}) {
  return (
    <EmployeeSalaryLateEarlyDeductTable
      isLoading={isLoading}
      dataSource={lateEarlyDeductList}
      pagination={pagination}
      onChange={onChange}
    />
  );
}

export default EmployeeSalaryLateEarlyDeduct;
